class ProductsShopifyAdapter {
  constructor(source_product) {
    this.source = 'ShopifyGraphql'
    this.source_product = source_product;

    this.id = this.productId();
    this.handle = this.productHandle();
    this.available = this.productAvailable();
    this.requires_selling_plan = this.requiresSellingPlan();
    this.title = this.productTitle();
    this.description = this.productDescription();
    this.image = this.productImage();
    this.price = this.productPrice();
    this.price_currency = this.productPriceCurrency();
    this.options = this.productOptions();
    this.variants = this.productVariants();
    this.compare_at_price = this.productCompareAtPrice();
    this.redirect_url = this.productRedirectUrl();
    this.subscriptions = this.productSubscriptions();
    this.imageList = this.productImageList();
    this.collections = this.productCollections();
    this.product_type = this.productSourceType();
    this.tags = this.productTags();
    this.variant_images = this.productVariantImages();
    this.selected_options = this.productSelectedOptions();
    this.is_variant = false;
  }

  productId() {
    return this.source_product?.id?.split("/").pop();
  }

  productHandle() {
    return this.source_product?.handle || this.source_product?.product?.handle;
  }

  productAvailable() {
    return this.source_product?.availableForSale;
  }

  requiresSellingPlan() {
    return this.source_product?.requiresSellingPlan || this.source_product?.product?.requiresSellingPlan || false;
  }

  productTitle() {
    return this.source_product?.title;
  }

  productDescription() {
    return this.source_product?.descriptionHtml;
  }

  productImage() {
    return this.source_product?.featuredImage?.url || this.source_product?.image?.url;
  }

  productImageList() {
    return this.source_product?.images?.edges?.map((f) => f.node).flat(1)
  }

  productSubscriptions() {
    return this.source_product?.sellingPlanGroups?.edges.map((f) => {
      return {
        name: f.node?.name,
        options: f.node?.options,
        sellingPlans: f.node.sellingPlans?.edges?.map((f) => f.node)
      }
    }) || [];
  }

  productPrice() {
    return (this.source_product?.priceRange?.minVariantPrice?.amount || this.source_product?.price?.amount);
  }

  productPriceCurrency() {
    return this.source_product?.priceRange?.minVariantPrice?.currencyCode || this.source_product?.price?.currencyCode;
  }

  productCompareAtPrice() {
    if (!this.source_product?.compareAtPrice) return null;

    return this.source_product?.compareAtPrice?.amount * 100;
  }

  productOptions() {
    return this.source_product?.options || [];
  }

  productStockQuantity() {
    return this.source_product?.quantityAvailable || this.source_product?.totalInventory;
  }

  productRedirectUrl() {
    return `/products/${this.productHandle()}`;
  }

  productCollections() {
    return this.source_product?.collections?.edges?.map((f) => f.node) || [];
  }

  productSourceType() {
    return this.source_product?.productType
  }

  productTags() {
    return this.source_product?.tags
  }

  productSelectedOptions() {
    return this.source_product?.selectedOptions
  }

  productVariantImages() {
    const uniqueEdges = new Set();

    return this.source_product?.variants?.edges?.reduce((result, edge) => {
      const src = edge.node?.image?.url;

      if (!uniqueEdges.has(src)) {
        uniqueEdges.add(src);
        result.push({
          variant_id: edge.node.id,
          src: src
        });
      }

      return result;
    }, []);
  }

  productVariants() {
    if (this.source_product?.id?.includes('ProductVariant')) {
      return [this];
    }

    return this.source_product?.variants?.edges?.map((f) => {
      const adaptedVariant = new ProductsShopifyAdapter(f.node);

      return {
        ...adaptedVariant,
        is_variant: true,
        variant_title: `${this.productTitle()} - ${adaptedVariant.title}`,
        product_id: this.productId(),
        redirect_url: `${this.productRedirectUrl()}?variant=${adaptedVariant.id}`,
        description: this.productDescription(),
        options: f.node?.selectedOptions?.map((opt) => {
          return {
            ...opt,
            values: [opt.value]
          }
        }) || [],
        subscriptions: f.node?.sellingPlanAllocations?.edges.map((allocation) => {
          const priceAdjustment = allocation.node?.priceAdjustments?.[0];
          return {
            name: allocation.node?.sellingPlan?.name,
            options: allocation.node?.sellingPlan?.options,
            sellingPlans: [{
              ...allocation.node?.sellingPlan,
              price: priceAdjustment?.price?.amount,
              compareAtPrice: priceAdjustment?.compareAtPrice?.amount,
              perDeliveryPrice: priceAdjustment?.perDeliveryPrice?.amount,
              priceCurrency: priceAdjustment?.price?.currencyCode
            }]
          }
        }) || []
      };
    }) || [];
  }
}

if (typeof window !== 'undefined' && typeof window.convertflow == 'undefined') {
  window.ProductsShopifyAdapter = ProductsShopifyAdapter;
}
